import { render } from "./RequisicaoDetalhe.vue?vue&type=template&id=b44d7cf4&scoped=true"
import script from "./RequisicaoDetalhe.vue?vue&type=script&lang=js"
export * from "./RequisicaoDetalhe.vue?vue&type=script&lang=js"

import "./RequisicaoDetalhe.vue?vue&type=style&index=0&id=b44d7cf4&scoped=true&lang=css"
import "./RequisicaoDetalhe.vue?vue&type=style&index=1&id=b44d7cf4&lang=css"
import "./RequisicaoDetalhe.vue?vue&type=style&index=2&id=b44d7cf4&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b44d7cf4"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QInput,QBtn,QTooltip,QDialog,QCard,QCardSection,QList,QItem,QItemSection,QItemLabel,QCardActions,QTable,QImg,QSelect,QTd,QRadio,QPopupProxy,QDate,QSpinner,QCheckbox,QField});qInstall(script, 'directives', {ClosePopup});
